import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router";
import { ErrorBoundary } from "@/components/error-boundary";
import { LoadingOverlay } from "@/components/loading-overlay";
import { Toaster } from "@/components/ui/sonner";
import { A11yProvider } from "@/contexts/a11y-context";
import { queryClient } from "./lib/query-client";
import { router } from "./router";

function App() {
	return (
		<ErrorBoundary>
			<QueryClientProvider client={queryClient}>
				<A11yProvider>
					<RouterProvider router={router} />
					<Toaster />
					<LoadingOverlay />
				</A11yProvider>
			</QueryClientProvider>
		</ErrorBoundary>
	);
}

export default App;
